module.exports = __webpack_public_path__ + "img/banner_8.576ee008.png";